import { Divider, Stack } from "@mui/material";
import { ModulePrimaryHeadline } from "src/components-mui/common/module-headlines";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";
import { ListsPeriodFilter } from "src/components-mui/modules/underlying-lists-module/components/lists-period-filter";
import { UnderlyingListDaysCount } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";
import {
    UNDERLYING_LIST_SECTION_DESCRIPTION_TEST_ID,
    UNDERLYING_LIST_SECTION_HEADING_TEST_ID,
} from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.test-ids";

interface IListsHeaderProps {
    title: string;
    titleAsH1: boolean;
    description: string;
    daysCount: UnderlyingListDaysCount;
    onDaysCountChange: (daysCount: UnderlyingListDaysCount) => void;
}

export const ListsHeader = ({ title, titleAsH1, description, daysCount, onDaysCountChange }: IListsHeaderProps) => (
    <Stack sx={{ gap: { xs: 4, sm: 3 } }}>
        <ModulePrimaryHeadline titleAsH1={titleAsH1} data-test-id={UNDERLYING_LIST_SECTION_HEADING_TEST_ID}>
            {title}
        </ModulePrimaryHeadline>
        <Stack sx={{ gap: 3 }}>
            {description && <SimpleRichText text={description} fontSize={["sm", "md"]} data-test-id={UNDERLYING_LIST_SECTION_DESCRIPTION_TEST_ID} />}
            <Divider sx={{ borderColor: "gray.100" }} />
            <ListsPeriodFilter daysCount={daysCount} onChange={onDaysCountChange} />
        </Stack>
    </Stack>
);
